import {createVuetify} from "vuetify";
import {custom, aliases} from "~/utils/customIcons";
import colors from 'vuetify/util/colors'
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "vuetify/lib/styles/main.sass";

export default defineNuxtPlugin((app) => {
    const vuetify = createVuetify({
        ssr: true,
        components,
        directives,
        theme: {
            defaultTheme: "light",
            themes: {
                light: {
                    colors: {
                        surface: colors.shades.white,
                        secondary: colors.grey.lighten2,
                        secondaryLight: colors.grey.lighten5,
                        content: colors.grey.lighten5,
                        table: colors.grey.lighten4,
                        primary: colors.indigo.base,
                        secondaryOpacityHalf: colors.grey.lighten1,
                        vector: colors.blue.lighten4,
                        surfaceAccent: colors.grey.lighten3,
                        surfaceAccentLight: colors.grey.lighten4,
                        hover: colors.blue.lighten5
                    },
                }
            },
        },
        icons: {
            defaultSet: "custom",
            aliases,
            sets: {
                custom,
            },
        }
    });
    app.vueApp.use(vuetify);
});
